<script lang="ts">
  import { strings } from '../../strings';
  import Button from '../../ui/Button.svelte';
  import Dialog from '../../ui/Dialog.svelte';

  interface Props {
    /** Loading a legacy v2 (Imgur) list. */
    loading: boolean;
    /** Error message once loading failed, else null. */
    error: string | null;
    ondismiss: () => void;
  }

  let { loading, error, ondismiss }: Props = $props();
  let open = $derived(error !== null);
</script>

{#if loading}
  <div
    class="fixed inset-0 z-40 grid place-items-center bg-canvas/80 backdrop-blur-sm"
    role="status"
    aria-live="polite"
  >
    <div class="flex flex-col items-center gap-3">
      <div class="grid w-72 gap-2" aria-hidden="true">
        {#each [1, 0.8, 0.9, 0.6] as width, i (i)}
          <div class="h-3 animate-pulse rounded bg-line" style:width="{width * 100}%"></div>
        {/each}
      </div>
      <p class="text-sm text-ink-muted">{strings.loadingLegacy}</p>
    </div>
  </div>
{/if}

<Dialog bind:open title={strings.legacyFailedTitle} description={error ?? ''} onclose={ondismiss}>
  {#snippet footer()}
    <Button variant="primary" onclick={() => (open = false)}>{strings.startFresh}</Button>
  {/snippet}
</Dialog>
